import { useHotelsStyles, useModuleBEM } from "@b2bportal/core-themes";
import {
  CoreHotelsComponent,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import { Button, ButtonTypeEnum } from "@b2bportal/core-ui";
import type { Lodging } from "@b2bportal/lodging-api";
import { HotelShopPriceLoading } from "@tenant/hotels";
import { PackagePriceText } from "@tenant/packages";
import clsx from "clsx";
import { usePackageHotelShopBookingSection } from "./hook";
import defaultStyles from "./HotelShopBookingSection.module.scss";

export interface HotelShopBookingSectionProps extends PlatformComponentProps {
  hotel: Lodging;
  goToNextStep: () => void;
  rateId?: string;
}

const COMPONENT_KEY = CoreHotelsComponent.HotelShopBookingSection;

export const PackageHotelShopBookingSection = (
  props: HotelShopBookingSectionProps
) => {
  const styles = useHotelsStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const viewProps = usePackageHotelShopBookingSection(props);

  const {
    isLoading,
    isAvailable,
    showPointsPricing,
    hasTenantSpecific,
    text,
    nextStep,
    packageType,
    totalPackageSavings,
  } = viewProps;

  return (
    <div className={cn("container")}>
      <div className={clsx(block, props.className)}>
        {isLoading ? (
          <HotelShopPriceLoading />
        ) : (
          <>
            {totalPackageSavings && (
              <div
                className={cn("savings-banner")}
                role="status"
                aria-live="polite"
              >
                {totalPackageSavings}
              </div>
            )}
            <div className={cn("pricing-info", { unavailable: !isAvailable })}>
              <PackagePriceText
                showPointsPricing={showPointsPricing}
                hasTenantSpecific={hasTenantSpecific}
                unitPriceRewards={text.perUnitRewards}
                unitPrice={text.perUnitPrice}
                totalPrice={text.totalPrice}
                packageType={packageType}
                unavailableText={viewProps.unavailable}
              />
            </div>
            <Button
              disabled={nextStep == null}
              className={cn("choose-room")}
              onClick={() => nextStep?.()}
              buttonType={ButtonTypeEnum.Primary}
            >
              {text.roomCTA}
            </Button>
          </>
        )}
      </div>
    </div>
  );
};
